import { render } from "./CatMotivosRechazoForm.vue?vue&type=template&id=75880086&scoped=true"
import script from "./CatMotivosRechazoForm.vue?vue&type=script&lang=js"
export * from "./CatMotivosRechazoForm.vue?vue&type=script&lang=js"

import "./CatMotivosRechazoForm.vue?vue&type=style&index=0&id=75880086&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75880086"]])

export default __exports__